import template from "./tnt_bypass_code.html";
import controller from "./tnt_bypass_code.controller";
import "./tnt_bypass_code.scss"
let branchManagementTntBypassCodeComponent = {
  restrict: "E",
  bindings: {},
  template,
  controller
};

export default branchManagementTntBypassCodeComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/tnt_bypass_code/tnt_bypass_code.component.js